/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are the Toolverse F1 Fantasy tools free?`)
};

const es_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son gratuitas las herramientas de F1 Fantasy de Toolverse?`)
};

const de_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind die F1-Fantasy-Werkzeuge von Toolverse kostenlos?`)
};

const nl_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn de F1 Fantasy-tools van Toolverse gratis?`)
};

const fr_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les outils F1 Fantasy de Toolverse sont-ils gratuits ?`)
};

const it_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli strumenti F1 Fantasy di Toolverse sono gratuiti?`)
};

const pt_br2_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As ferramentas de F1 Fantasy da Toolverse são gratuitas?`)
};

const pt_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As ferramentas de F1 Fantasy da Toolverse são gratuitas?`)
};

const ja_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToolverseのF1ファンタジーツールは無料ですか？`)
};

const zh_f1_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse 的 F1 Fantasy 工具是免费的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_faq2_q", locale)
	if (locale === "en") return en_f1_faq2_q(inputs)
	if (locale === "es") return es_f1_faq2_q(inputs)
	if (locale === "de") return de_f1_faq2_q(inputs)
	if (locale === "nl") return nl_f1_faq2_q(inputs)
	if (locale === "fr") return fr_f1_faq2_q(inputs)
	if (locale === "it") return it_f1_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_faq2_q(inputs)
	if (locale === "pt") return pt_f1_faq2_q(inputs)
	if (locale === "ja") return ja_f1_faq2_q(inputs)
	return zh_f1_faq2_q(inputs)
};